import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "unlogged-area-footer",
  "aria-label": "Footer"
}
const _hoisted_2 = {
  "aria-label": "Footer Navigation",
  role: "navigation"
}
const _hoisted_3 = {
  class: "unlogged-area-footer__menu",
  role: "menu"
}
const _hoisted_4 = {
  key: 0,
  role: "menuitem"
}
const _hoisted_5 = {
  class: "unlogged-area-footer__link",
  href: "/Imprint",
  role: "button",
  tabindex: "0"
}
const _hoisted_6 = { key: 1 }

import { useAppStore } from '@/stores/app.store';
import useTranslations from '@/composables/useTranslations';
import { computed, ref } from 'vue';
import LanguageSelector from '@/components/common/languageSelector/LanguageSelector.vue';
import FeedbackDialog from '../common/dialogs/DialogFeedback.vue';
import { layoutAreaTypes } from '@/types/layoutTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'UnloggedAreaFooter',
  setup(__props) {

const appStore = useAppStore();
const { translate: t } = useTranslations();

const feedbackDialogRef = ref();

const systemSettings = computed(() => {
  return appStore.systemSettings;
});

function handleFeedbackBtnClick() {
  feedbackDialogRef.value.openDialog();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createVNode(LanguageSelector, { role: "group" }),
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (systemSettings.value?.footerMenuViewModel?.isImprintOnLoginPageVisible)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createElementVNode("a", _hoisted_5, _toDisplayString(systemSettings.value?.footerMenuViewModel?.imprintLabel), 1)
              ]))
            : _createCommentVNode("", true),
          (
            systemSettings.value?.footerMenuViewModel?.isYourFeedbackOnLoginPageVisible &&
            systemSettings.value?.allowAnonymousFeedback
          )
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createElementVNode("span", {
                  class: "unlogged-area-footer__link unlogged-area-footer__link--feedback",
                  role: "button",
                  tabindex: "0",
                  onKeyup: _withKeys(handleFeedbackBtnClick, ["enter"]),
                  onClick: handleFeedbackBtnClick
                }, _toDisplayString(_unref(t)('Page.FeedbackFormLink')), 33)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(FeedbackDialog, {
      ref_key: "feedbackDialogRef",
      ref: feedbackDialogRef,
      "layout-area-type": _unref(layoutAreaTypes).Unlogged
    }, null, 8, ["layout-area-type"])
  ], 64))
}
}

})